/**
 * Helper functions for temporal heatmap calculations and historic zone filtering
 */

import { fmtDateTime } from '../../../Utils/format';

/**
 * Filters zones based on historical timeframe.
 * Keeps currently inactive zones if they were active during [fromDate, toDate],
 * and excludes zones created after toDate.
 */
export function filterHistoricalZones(zones, fromDate, toDate) {
  if (!Array.isArray(zones)) return [];
  if (!fromDate && !toDate) return zones;

  const toMs = toDate ? new Date(toDate).getTime() : Infinity;
  const fromMs = fromDate ? new Date(fromDate).getTime() : 0;

  return zones.filter((z) => {
    const createdMs = z.createdAt ? new Date(z.createdAt).getTime() : 0;
    const updatedMs = z.updatedAt ? new Date(z.updatedAt).getTime() : Infinity;

    // Exclude zones created AFTER the selected period
    if (createdMs > toMs) return false;

    // Keep active zones or inactive zones that were active during [fromDate, toDate]
    return z.isActive || updatedMs >= fromMs;
  });
}

/**
 * Format temporal window for display in European format (DD/MM/YYYY · HH:mm)
 */
export function formatTemporalWindow(fromDate, toDate, t) {
  if (!fromDate && !toDate) {
    return t ? t('allTime', 'Desde sempre') : 'Desde sempre';
  }
  const fromStr = fromDate ? fmtDateTime(fromDate, false) : '';
  const toStr = toDate ? fmtDateTime(toDate, false) : '';
  return `${fromStr} - ${toStr}`;
}
